export type TravelersTexts = {
  adult: string;
  adults: string;
  child: string;
  children: string;
  infant?: string;
  infants?: string;
};

const getTravelersText = (
  numberOfAdults: number,
  numberOfChildren: number | undefined,
  numberOfInfants: number | undefined,
  texts: TravelersTexts,
) => {
  const { adult, adults, child, children, infant, infants } = texts;

  const formatText = (
    count: number | undefined,
    singular: string | undefined,
    plural: string | undefined,
  ) => (count && count > 0 ? `${count} ${count === 1 ? singular : plural}` : '');

  const adultsText = formatText(numberOfAdults, adult, adults);
  const childrenText = formatText(numberOfChildren, child, children);
  const infantsText = formatText(numberOfInfants, infant, infants);

  return [adultsText, childrenText, infantsText].filter((text) => text).join(', ');
};

export default getTravelersText;
